<template>
  <div>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;900&display=swap" rel="stylesheet">
    <div class="metric-card">
      <div class="metric-title">{{title}}</div>
      <div class="metric-value">{{stat}}</div>
    </div>
  </div>
</template>

<script>

  export default {
    props: ["title", "stat"],

  };
</script>

<style>
  .metric-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  }

  .metric-title {
    font-size: 16px;
    color: #666;
    margin-bottom: 10px;
    font-weight: 600;
  }

  .metric-value {
    font-size: 28px;
    font-weight: 900;
  }

  .metric-trend {
    font-size: 14px;
    margin-top: 5px;
  }

  .trend-up {
    color: #10b981;
  }

  .trend-down {
    color: #ef4444;
  }
</style>
